import { DataGrid, DataGridProps, GridToolbar } from "@mui/x-data-grid";
import { alpha } from "@mui/material/styles";

type CustomDataGridProps = {
} & DataGridProps;

const CustomDataGrid = ({ loading, ...props }: CustomDataGridProps) => {
    return (
        <DataGrid
            pageSizeOptions={[5, 10]}
            disableRowSelectionOnClick
            {...props}
            slots={{
                toolbar: GridToolbar,
                ...props.slots,
            }}
            slotProps={{
                // ...props.slotProps,
                toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                    sx: {
                        py: .5,
                        px: 1.5,
                        '& .MuiButtonBase-root': {
                            color: 'text.primary',
                        },
                    },
                },
            }}
        />
    )
}

export default CustomDataGrid;
